import React from "react";
import savings from "../images/savings.jpg"
import reviews from "../images/reviews.png"


function WhyGoodGuys() {
  return (
    <>
    <div className="whygoodguyscont">
      <div className="whygoodguys">
        <div className="whygoodguy-style">
            <div className="whygoodey" >
                    <h1>Why Choose GoodGuys?</h1>
                    {/* <h3>Because It's Time For A Fresh Room!</h3>
                    <h3>And We're Just The Right People For The Job!</h3> */}

                </div>
            </div>
        </div>
          <div className="brickdownchitown">
                <div className="brickup">
                        <div className="brickup1">
                            <h1>Why choose GoodGuys?</h1>
                            <div className="line"></div>
                        </div>
                        <div className="bruckup">
                            <h3>Our cleaning and service capabilities are unmatched.</h3>
                          
                            <div className="contaflex">
                              <p className="flexin"> GoodGuys is recognized as a leader in our industry and is highly 
                              recommended by design professionals who rely on our expertise for the cleaning
                               of installed carpet, Oriental and area rugs, upholstered furniture, stone 
                               and tile as well as the fabrication of custom carpet designs, edge treatments 
                               and rug repair and reweaving. We are pleased that most of our work comes through 
                               repeat business and referrals from decades of satisfied clients.  They value our
                                experienced service team, convenient scheduling, friendly service and kept 
                                promises.  We keep our promises, with no surprises!</p>
                            </div>
                           
                        </div>
                         <div className="contafirst">
                            <div className="firstpara">
                            <h1>Friendly, Caring Service Professionals</h1>
                        </div>
                        <div className="secondpara">
                            <h3>Our cleaning and service capabilities are unmatched.</h3>
                          
                            <div className="contaconta">
                              <p className="sideleft"> GoodGuys is recognized as a leader in our industry and is highly 
                              recommended by design professionals who rely on our expertise for the cleaning
                               of installed carpet, Oriental and area rugs, upholstered furniture, stone 
                               and tile as well as the fabrication of custom carpet designs, edge treatments 
                               and rug repair and reweaving. We are pleased that most of our work comes through 
                               repeat business and referrals from decades of satisfied clients.  They value our
                                experienced service team, convenient scheduling, friendly service and kept 
                                promises.  We keep our promises, with no surprises!</p>
                            </div>
                           
                         <button>OUR PEOPLE</button>
                        </div>
                         </div>
                          <div className="conta-eco">
                             <div className="firstpara">
                            <h1>Friendly, Caring Service Professionals</h1>
                        </div>
                        <div className="secondpara">
                            <h3>Our cleaning and service capabilities are unmatched.</h3>
                          
                            <div className="contaconta">
                              <p className="sideleft"> GoodGuys is recognized as a leader in our industry and is highly 
                              recommended by design professionals who rely on our expertise for the cleaning
                               of installed carpet, Oriental and area rugs, upholstered furniture, stone 
                               and tile as well as the fabrication of custom carpet designs, edge treatments 
                               and rug repair and reweaving. We are pleased that most of our work comes through 
                               repeat business and referrals from decades of satisfied clients.  They value our
                                experienced service team, convenient scheduling, friendly service and kept 
                                promises.  We keep our promises, with no surprises!</p>
                            </div>
                           
                         <button>OUR PEOPLE</button>
                        </div>
                          </div>
                           <div className="contsavings">
                           <img className="contsavingsimg" style={{ height: "425px", width: "725px"}} src={savings} alt="" />
                           <div className="contsavingsshift">
                    
                        <div className="secondpara">
                        <h1>Friendly, Caring Service Professionals</h1>
                            <h3>Our cleaning and service capabilities are unmatched.</h3>
                          
                            <div className="contaconta">
                              <p className="sideleft"> GoodGuys is recognized as a leader in our industry and is highly 
                              recommended by design professionals who rely on our expertise for the cleaning
                               of installed carpet, Oriental and area rugs, upholstered furniture, stone 
                               and tile as well as the fabrication of custom carpet designs, edge treatments 
                               and rug repair and reweaving. We are pleased that most of our work comes through 
                               repeat business and referrals from decades of satisfied clients.  They value our
                                experienced service team, convenient scheduling, friendly service and kept 
                                promises.  We keep our promises, with no surprises!</p>
                            </div>
                           
                         <button>OUR PEOPLE</button>
                         </div>
                           </div>
                           </div>
                           <div className="contreviews">
                           
                           <div className="contreviewshift">
                    
                        <div className="secondpara">
                        <h1>Friendly, Caring Service Professionals</h1>
                            <h3>Our cleaning and service capabilities are unmatched.</h3>
                          
                            <div className="contaconta">
                              <p className="sideleft"> GoodGuys is recognized as a leader in our industry and is highly 
                              recommended by design professionals who rely on our expertise for the cleaning
                               of installed carpet, Oriental and area rugs, upholstered furniture, stone 
                               and tile as well as the fabrication of custom carpet designs, edge treatments 
                               and rug repair and reweaving. We are pleased that most of our work comes through 
                               repeat business and referrals from decades of satisfied clients.  They value our
                                experienced service team, convenient scheduling, friendly service and kept 
                                promises.  We keep our promises, with no surprises!</p>
                            </div>
                         <button>OUR PEOPLE</button>
                         </div>
                           <img className="contreviewsimg" style={{ height: "355px", width: "570px"}} src={reviews} alt="" />
                           </div>
                           </div>
                    </div>
                </div>
                </div>
            {/* <Parallax featuredImage1={commercialshed} featuredImage2={commercialclean} commpar={true} isNeeded = {false} />


             <div className="imgcontainer">
                        <img src={commercialslick} alt="" />
                    </div> */}
   </>
  );
}

export default WhyGoodGuys;
